<template>
    <a-modal
            :width="fenceConfigStatus == 'process' ? '60%': '50%'"
            v-model="addRuleTemplate"
            :title="$t('supervise.newGroup')"
            :maskClosable="maskClosable"
            destroyOnClose
            :style="fenceConfigStatus == 'process' ? {'top': '20px'} : null">

        <template slot="footer">
            <span>
                <a-button @click="handleCancel">{{$t('global.cancel')}}</a-button>
                <a-button type="primary" v-if="confirmStatus == 'process'" @click="handleOk">{{$t('global.OK')}}</a-button>
            </span>
        </template>

        <div style="padding:10px;padding-top:0px">
            <a-steps>
                <a-step :status="basicStatus" :title="$t('global.basicInfo')">
                    <a-icon :type="basicStatus == 'process' ? 'loading' : 'idcard'" slot="icon"/>
                </a-step>
                <a-step :status="basicConfigStatus" :title="$t('supervise.option')">
                    <a-icon :type="basicConfigStatus == 'process' ? 'loading' : 'solution'" slot="icon"/>
                </a-step>
                <a-step :status="smartConfigStatus" :title="$t('supervise.smartRule')">
                    <a-icon :type="smartConfigStatus == 'process' ? 'loading' : 'laptop'" slot="icon"/>
                </a-step>
                <a-step :status="fenceConfigStatus" :title="$t('supervise.mapFence')">
                    <a-icon :type="fenceConfigStatus == 'process' ? 'loading' : 'gateway'" slot="icon"/>
                </a-step>
                <a-step :status="confirmStatus" :title="$t('supervise.complete')">
                    <a-icon :type="confirmStatus == 'process' ? 'loading' : 'check'" slot="icon"/>
                </a-step>
            </a-steps>
        </div>

        <div style="padding:10px;">
            <div>
                <z-add-template-basic
                        ref="addRuleTemplateBasic"
                        :basicStatus="basicStatus"
                        @gotoNext="gotoBasicConfig">
                </z-add-template-basic>

                <z-add-template-basic-config
                        ref="addTemplateBasicConfig"
                        :basicConfigStatus="basicConfigStatus"
                        @gotoPrevious="gotoBasic"
                        @gotoNext="gotoSmartConfig">
                </z-add-template-basic-config>

                <z-add-template-smart-config
                        ref="addTemplateSmartConfig"
                        :smartConfigStatus="smartConfigStatus"
                        @gotoPrevious="gotoBasicConfig"
                        @gotoNext="gotoFenceConfig">
                </z-add-template-smart-config>

                <z-add-template-fence-config
                        ref="addTemplateFenceConfig"
                        :fenceConfigStatus="fenceConfigStatus"
                        @gotoPrevious="gotoSmartConfig"
                        @gotoNext="gotoConfirm">
                </z-add-template-fence-config>

                <z-add-template-confirm
                        :confirmStatus="confirmStatus"
                        :basicParam="basicParam"
                        :basicConfigParam="basicConfigParam"
                        :smartConfigParam="smartConfigParam"
                        :fenceParam="fenceParam"
                        @gotoPrevious="gotoFenceConfig">
                </z-add-template-confirm>
            </div>
        </div>
    </a-modal>
</template>

<script>
    import ZAddTemplateBasic from '@/views/ruletemplate/AddTemplateBasic.vue'
    import ZAddTemplateBasicConfig from '@/views/ruletemplate/AddBasicConfig.vue'
    import ZAddTemplateSmartConfig from '@/views/ruletemplate/AddSmartConfig.vue'
    import ZAddTemplateFenceConfig from '@/views/ruletemplate/AddFenceConfig.vue'
    import ZAddTemplateConfirm from '@/views/ruletemplate/AddTemplateConfirm.vue'
    import config from '@/config'
    import moment from 'moment'

    export default {
        name: 'ZAddRuleTemplate',
        data() {
            return {
                maskClosable: false,
                addRuleTemplate: false,
                basicStatus: 'process',
                basicConfigStatus: 'wait',
                smartConfigStatus: 'wait',
                fenceConfigStatus: 'wait',
                confirmStatus: 'wait',
                basicParam: null,
                basicConfigParam: null,
                smartConfigParam: null,
                fenceParam: null,
                orgId: null
            }
        },
        components: {
            ZAddTemplateSmartConfig,
            ZAddTemplateBasic,
            ZAddTemplateBasicConfig,
            ZAddTemplateFenceConfig,
            ZAddTemplateConfirm
        },
        methods: {
            handleCancel() {
                this.addRuleTemplate = false
            },
            handleOk() {
                let param = {}
                let createEntityGroupModel = {}
                let ruleTemplateModel = {}
                param.createEntityGroupModel = createEntityGroupModel
                param.ruleTemplateModel = ruleTemplateModel
                createEntityGroupModel.name = this.basicParam.templateName
                createEntityGroupModel.description = this.basicParam.templateDescription
                ruleTemplateModel.name = this.basicParam.templateName
                ruleTemplateModel.description = this.basicParam.templateDescription
                ruleTemplateModel.locateFreq = this.basicConfigParam.locateFreq
                ruleTemplateModel.autoAdjust = this.basicConfigParam.autoAdjust
                ruleTemplateModel.autoPowerUp = this.basicConfigParam.autoPowerUp
                ruleTemplateModel.autoPowerDown = this.basicConfigParam.autoPowerDown
                ruleTemplateModel.customLocate = this.basicConfigParam.customLocate
                ruleTemplateModel.rollCall = this.smartConfigParam.rollCalls
                ruleTemplateModel.heartRate = this.smartConfigParam.heartClocks
                if (this.fenceParam.data && this.fenceParam.data.length > 0) {
                    let fences = []
                    ruleTemplateModel.fences = fences
                    this.fenceParam.data.map(function (item) {
                        let fence = {}
                        fence.applyAll = item.applyAll
                        fence.name = item.fenceName
                        fence.type = item.fenceType
                        if (item.forbidType == 'in') {
                            fence.opt = 1
                        } else if (item.forbidType == 'out') {
                            fence.opt = 2
                        }
                        fence.coordType = 'BD09'
                        if (item.acls) {
                            let acls = []
                            item.acls.split('/').map(function (acl) {
                                let startTime = acl.split('~')[0]
                                let endTime = acl.split('~')[1]
                                let startHour = parseInt(startTime.split(':')[0])
                                let startMinute = parseInt(startTime.split(':')[1])
                                let endHour = parseInt(endTime.split(':')[0])
                                let endMinute = parseInt(endTime.split(':')[1])
                                let start = moment().startOf('day').unix() + (startHour * 60 + startMinute) * 60
                                let end = moment().startOf('day').unix() + (endHour * 60 + endMinute) * 60
                                let value = start + '~' + end + '~' + '1'
                                acls.push(value)
                            })
                            fence.acl = acls
                            console.log(acls)
                        }
                        let parameter = {}
                        fence.parameter = parameter
                        parameter.points = []
                        if (item.fenceType == 'circle') {
                            parameter.radius = item.overlays[0].getRadius()
                            let subPoints = []
                            subPoints.push(item.overlays[0].getCenter())
                            parameter.points.push(subPoints)
                        }
                        if (item.fenceType == 'polygon') {
                            let subPoints = []
                            subPoints = item.overlays[0].getPath()
                            if(subPoints[0].lat != subPoints[subPoints.length -1].lat || subPoints[0].lng != subPoints[subPoints.length -1].lng){
                                subPoints.push(subPoints[0])
                            }
                            parameter.points.push(subPoints)
                        }
                        if (item.fenceType == 'district') {
                            item.overlays.map(function (item) {
                                let subPoints = []
                                subPoints.push(...item.getPath())
                                if(subPoints[0].lat != subPoints[subPoints.length -1].lat || subPoints[0].lng != subPoints[subPoints.length -1].lng){
                                    subPoints.push(subPoints[0])
                                }
                                parameter.points.push(subPoints)
                            })
                        }
                        fences.push(fence)
                    })
                }
                this.$http.post(config.api.entity_group_url + '/' + this.orgId, param).then((response) => {
                    if (response.code == 0) {
                        this.addRuleTemplate = false
                        // this.$message.success('操作成功')
                        this.$notification.success({
                          message: this.$t('global.commitSuccess')
                        })
                        this.$emit("addSuccess", response.result.id)
                    } else {
                      this.$message.error(response.desc)
                    }
                })
            },
            showModel(orgId) {
                this.orgId = orgId
                this.addRuleTemplate = true
                let _this = this
                setTimeout(function () {
                    _this.$refs["addRuleTemplateBasic"].init()
                    _this.$refs["addTemplateBasicConfig"].init()
                    _this.$refs["addTemplateSmartConfig"].init()
                    _this.$refs["addTemplateFenceConfig"].init()
                    _this.basicStatus = 'process'
                    _this.basicConfigStatus = 'wait'
                    _this.smartConfigStatus = 'wait'
                    _this.fenceConfigStatus = 'wait'
                    _this.confirmStatus = 'wait'
                }, 200)
            },
            gotoBasic() {
                this.basicStatus = 'process'
                this.basicConfigStatus = 'wait'
            },
            gotoBasicConfig(basicParam) {
                if (basicParam) {
                    this.basicParam = basicParam
                }
                this.basicStatus = 'finish'
                this.basicConfigStatus = 'process'
                this.smartConfigStatus = 'wait'
            },
            gotoSmartConfig(basicConfigParam) {
                if (basicConfigParam) {
                    this.basicConfigParam = basicConfigParam
                }
                this.basicConfigStatus = 'finish'
                this.smartConfigStatus = 'process'
                this.fenceConfigStatus = 'wait'
            },
            gotoFenceConfig(smartConfigParam) {
                if (smartConfigParam) {
                    this.smartConfigParam = smartConfigParam
                }
                this.smartConfigStatus = 'finish'
                this.fenceConfigStatus = 'process'
                this.confirmStatus = 'wait'
            },
            gotoConfirm(fenceParam) {
                if (fenceParam) {
                    this.fenceParam = fenceParam
                }
                this.fenceConfigStatus = 'finish'
                this.confirmStatus = 'process'
            }
        }
    }
</script>